module.exports = __webpack_public_path__ + "media/images/fb-logo-62341ff02e62cadc2e1557271a553d3f.png";